import DOMPurify from 'dompurify'

function sanitizeHTML(dirty) {
  if (!dirty) return ''

  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'ul', 'ol', 'li', 'span', 'div', 'a'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'class', 'style'],
    ADD_ATTR: ['rel', 'target'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload'],

    hooks: {
      afterSanitizeAttributes: (node) => {
        if ('target' in node) node.setAttribute('target', '_blank')
        if (node.tagName && node.tagName.toLowerCase() === 'a') {
          node.setAttribute('rel', 'noopener noreferrer')
        }
      }
    }
  })
}

export function toPlaintext(html) {
  return DOMPurify.sanitize(html || '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
}

export default sanitizeHTML
